import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_URL}/tds`,
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

export const tdsReportApi = createApi({
  reducerPath: 'tdsReportApi',
  baseQuery,
  tagTypes: ['TdsReport', 'TdsSummary'],
  endpoints: (builder) => ({
    generateTdsReport: builder.query({
      query: ({ quarter, financialYear, format = 'json' }) => ({
        url: '/report',
        params: {
          quarter,
          financialYear,
          format
        }
      }),
      providesTags: ['TdsReport'],
    }),
    
    getTdsSummary: builder.query({
      query: () => '/summary',
      providesTags: ['TdsSummary'],
    }),
    
    downloadTdsReport: builder.mutation({
      query: ({ quarter, financialYear }) => ({
        url: '/report',
        params: {
          quarter,
          financialYear,
          format: 'csv'
        },
        responseHandler: async (response) => {
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `tds-report-${quarter ? `Q${quarter}-` : ''}${financialYear}.csv`;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          return { success: true };
        }
      }),
    }),
  }),
});

export const {
  useGenerateTdsReportQuery,
  useGetTdsSummaryQuery,
  useDownloadTdsReportMutation,
} = tdsReportApi;
